;var Share = (function(){
    var Share = {};

    Share.whatsapp = function whatsapp(url){
         window.open('https://api.whatsapp.com/send?text='+encodeURIComponent(url));
    };

    Share.facebook = function facebook(url){
         var winWidth = 566;
         var winHeight = 436;

         var winTop = (screen.height / 2) - (winHeight / 2);
         var winLeft = (screen.width / 2) - (winWidth / 2);

         window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url), 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width='+winWidth+',height='+winHeight);
    };

    Share.twitter = function twitter(url, descr){
        var winWidth = 660;
        var winHeight = 260;

        var winTop = (screen.height / 2) - (winHeight / 2);
        var winLeft = (screen.width / 2) - (winWidth / 2);
        window.open('https://twitter.com/share?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(descr), 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width='+winWidth+',height='+winHeight);
    };

    Share.linkedin = function linkedin(url, title, descr){
        var winWidth = 626;
        var winHeight = 436;

        var winTop = (screen.height / 2) - (winHeight / 2);
        var winLeft = (screen.width / 2) - (winWidth / 2);

        window.open('https://www.linkedin.com/sharing/share-offsite/?url='+(url), 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width='+winWidth+',height='+winHeight);
    };

    Share.pinterest = function pinterest(url) {
        var winWidth = 760;
        var winHeight = 720;

        var winTop = (screen.height / 2) - (winHeight / 2);
        var winLeft = (screen.width / 2) - (winWidth / 2);

         window.open('https://br.pinterest.com/pin/create/link/?url='+encodeURIComponent(url), 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width='+winWidth+',height='+winHeight);
    };

    Share.telegram = function telegran(url, text){
        window.open('https://t.me/share/url?url='+encodeURIComponent(url)+'&text='+encodeURIComponent(text));
    }

    Share.copyToClickBoard = function copyToClickBoard(url, $el){
        navigator.clipboard.writeText(url).then(function() {
            $el.find('.text-copy').addClass('show');

            if(!$el.find('.text-copy').hasClass('show')){

            }

            setTimeout(function(){
                $el.find('.text-copy').removeClass('show');
            }, 2000);
          }, function() {
            /* clipboard write failed */
            console.log('erro')
          });
    }

    return Share;
}());
